import React from "react";
import { useI18n } from "../i18n/I18nContext";
import { LegalPage } from "../components/LegalPage";
import { Seo } from "../components/Seo";

export default function PrivacyPage() {
  const { t } = useI18n();
  return (
    <>
      <Seo k="privacy" />
      <LegalPage data={t.privacyPage} testid="privacy-page" />
    </>
  );
}
